
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlK as ObiOwnShipControlKElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-k.js';
 
 
 

 
 export const ObiOwnShipControlK = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-k',
   elementClass: ObiOwnShipControlKElement,
   events: {
     
   }
  });
 
 